<template>
  <div>
    <toggle-collapse>
      <DevicesListFilters @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
    </toggle-collapse>
    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="6">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices" 
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('all'), id: 'all'},...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- camps  -->
          <b-col cols="6">
            <b-form-group :label="$t('Camp')">
              <v-select multiple  :close-on-select="false" v-model="request.camps" 
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name:$t('all'), id: 'all'},...camps]" :reduce="d => d.id" />
              <small v-if="errors && ('camps' in errors)" class="text-danger">
                {{ $t(errors['camps'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- suctions  -->
          <b-col cols="6">
            <b-form-group :label="$t('Suctions Area')">
              <v-select multiple :close-on-select="false"  v-model="request.suctions" 
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('all'), id: 'all'}, ...suctions]"
                :reduce="d => d.id" />
              <small v-if="errors && ('suctions' in errors)" class="text-danger">
                {{ $t(errors['suctions'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- dumps  -->
          <b-col cols="6">
            <b-form-group :label="$t('Dumps Area')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.dumps"
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('all'), id: 'all'}, ...dumps]" :reduce="d => d.id" />
              <small v-if="errors && ('dumps' in errors)" class="text-danger">
                {{ $t(errors['dumps'][0]) }}
              </small>
            </b-form-group>
          </b-col>



          <b-col md="12" sm="12">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD"
                
                 />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>


        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="loading"
        :getReport="getReport" :total="total" :from="from" :to="to" />

    </div>
  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref } from '@vue/composition-api'
import RainReportLogic from '@/app/reports/rain/logic'



import reportForm from '@/app/reports/rain/reportForm'
import DataTable from '@/views/reports/data-table/DataTable.vue'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'

import  ReportOptions from  '@/views/reports/components/options.js'

    
export default {
  name: 'RainReport',
  components: {
    BRow,
    BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert,
    BFormGroup,
    BFormInput, flatPickr,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    DevicesListFilters,
    ToggleCollapse,
    DataTable
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {
    const { devices } = FilterLogic()


    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {
      delete data['type']
      Object.assign(request.value, data);
    }

    const rangeDate = ref('')
    const tableRef = ref(null)
    const { camps, suctions, dumps } = reportForm()
    const { report_data, request, errors, loading, getReport, getReportForPdf, total, from, to } = RainReportLogic()
    const {pickerOptions} =ReportOptions(request.value)


    const filter_included_fields = ['day', 'day_weak', 'device', 'area', 'durationTime', 'serve', 'percent','owner','contract']

    const report_fields = [
      {
        key: 'index',
        label: 'id',
       
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },
      {
        key: 'day',
        label: 'day',
        sortable: false
      },
      {
        key: 'day_weak',
        label: 'day_weak',
        sortable: false
      },
      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'area',
        label: 'area',
        sortable: true
      },
      {
        key: 'durationTime',
        label: 'rainReport.durationTime',
        sortable: false
      },
      {
        key: 'serve',
        label: 'serve',
        sortable: false
      },
      {
        key: 'percent',
        label: 'percent',
        sortable: false
      },
     

    ]

   

    const report_wrapper = ref(null)








    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,


      devices,
      suctions,
      dumps,
      camps,

      pickerOptions,
      report_wrapper,


      request,
      loading,
      errors,
      divicesFilterd,
      merageFilterWithRequest
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
